import React from 'react';

const ticketConfig = {
    settings: {
        style: 'layout1',
        layout: {
            config: {
                needUserInfo: true,
                redirectOn401: true,
                footer: {
                    display: true
                }
            }
        }
    },
    routes: [
        {
            path: '/ticket/new-ticket/:categoryParam?/:subCategoryParam?',
            component: React.lazy(() => import('./new-ticket'))
        },
        {
            path: '/ticket/my-tickets',
            component: React.lazy(() => import('./tickets'))
        },
        {
            path: '/ticket/ticket-details/:ticketId',
            component: React.lazy(() => import('./ticket-details'))
        }
    ]
};

export default ticketConfig;